import styled, { css } from "styled-components";
import { TableDownload } from "../../Components/Icons/TableDownload";

export const Layout = styled.div`
  padding: 50px;
`;

export const TableTitle = styled.div`
  padding: 22px;
  width: 100%;
  text-align: left;
  background-color: #151633;
  color: white;
  font-size: 20px;
  font-weight: 600;

  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
`;

export const Table = styled.table`
  width: 100%;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  background: #fff;
  box-shadow: 0px 4px 8px -2px rgba(23, 23, 23, 0.1), 0px 2px 4px -2px rgba(23, 23, 23, 0.06);

  th,
  td {
    padding: 20px;
  }
`;

export const TableHead = styled.thead`
  border-bottom: 2px solid #ccc;
  text-align: left;
  background-color: #f8fafc;
  color: #1e293b;
  font-size: 14px;
  font-weight: 500;
`;

export const TableHeadFilter = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  cursor: ${({ canSort }) => (canSort ? "pointer" : "default")};
`;

export const TableBody = styled.tbody`
  & > tr td {
    border: 1px solid #ccc;
    border-left: 0;
    border-right: 0;
  }
  & > tr:last-child td {
    border-bottom: 0;
  }
  & > tr:last-child td:last-child {
    border-bottom-right-radius: 24px;
  }
  & > tr:last-child td:first-child {
    border-bottom-left-radius: 24px;
  }
  & > tr:nth-child(even) {
    background-color: #e6e6e6;
  }
  & > tr {
    border-radius: 24px;
    cursor: pointer;
    :hover {
      background-color: #d2d7ff80;
    }
  }
`;

export const Download = styled(TableDownload)`
  cursor: pointer;
  :hover {
    transition: transform ease-in-out 0.1s;
    transform: scale(1.05);
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PagesWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 600px;
  gap: 50px;
`;

export const PageNumberWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const PageNumber = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding-bottom: 1px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? "white" : "#151633")};
  background-color: ${({ isActive }) => (isActive ? "#151633" : "transparent")};
  :hover {
    background-color: #151633;
    color: white;
    transition: background-color 0.3s, color 0.3s;
  }

  border-radius: 123px;
  border: 1px solid #a5b4fc;
`;

export const PageArrow = styled.svg`
  ${({ isDisabled }) =>
    isDisabled
      ? css`
          cursor: default;
          pointer-events: none;
        `
      : css`
          cursor: pointer;
          pointer-events: auto;
          :hover {
            transform: scale(1.05);
            transition: transform ease-in-out 0.1s;
          }
        `}
`;

export const Status = styled.div`
  display: inline-flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 50px;
  border: ${({ isPaid }) => (isPaid ? "1px solid #22c55e" : "1px solid #F43F5E")};
  background: ${({ isPaid }) => (isPaid ? "#f0fdf4" : "#FFF1F2")};
`;

export const SelectContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const CustomSelect = styled.select`
  font-family: "Rubik", sans-serif;
  width: 100%;
  padding: 8px 15px;
  padding-right: 30px;
  appearance: none;
  border: 1px solid #4e4f87;
  border-radius: 50px;
  background: white;
  font-size: 13px;
  cursor: pointer;

  background: none;
  background-image: none;
`;

export const ArrowIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  pointer-events: none;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ResultsWrapper = styled.div``;
